import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

const WhatsAppWidget = () => {
  const whatsappNumber = "+61403601970";
  const message = "Hi! I'm interested in learning more about Ace Anchor's services.";
  const whatsappLink = `https://wa.me/${whatsappNumber.replace(/[^0-9]/g, "")}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 animate-fade-in"
    >
      <Button
        size="lg"
        className="rounded-full h-14 w-14 p-0 shadow-elegant hover:scale-110 transition-transform duration-300 bg-[#25D366] hover:bg-[#20BA5A]"
      >
        <MessageCircle className="h-6 w-6" />
        <span className="sr-only">Chat on WhatsApp</span>
      </Button>
    </a>
  );
};

export default WhatsAppWidget;
